import React, {useState, useEffect, useReducer} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {SVGICONS} from '@ey/icons';
import Input from '../../CoreWrappers/Input';
import styled from 'styled-components';
import env from '../../../util/env';
import {labels, currentResource} from '../../../util/utils';
import {UserType, promiseAreas, serviceURL, AdminRoles} from '../../../util/uiconstants';
import Utility from '../../../util/utilityfunctions';
import ModalControl from '../../Common/Modal/Modal';
import MotifModalBody from '@ey/motif-react-wrapper/ModalBody';
import { createAdminUser, getAllAdminUsers } from '../../../actions/AdminUser/AdminUserAction';
import TrackerLoader from '../../Common/LoadingIndicator/TrackerLoader';
import UserSearch from '../../Common/Search/CustomizedUsersearch';
import { UserLookupType, DefautAddGroupRoles, AdminGroupRoles } from '../../../util/uiconstants';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import MotifSelect from '@ey/motif-react-wrapper/Select';
import MotifOption from '@ey/motif-react-wrapper/Option';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import ErrorSummary from '../../Common/ErrorSummary/ErrorSummary';
import {setIsModalOpen} from '../../../actions/AccessGroups/SetIsModalOpen';
import {raiseJSValidationError, clearErrors} from '../../../actions/erroractions';
import Select from '../../CoreWrappers/Select';

function AddAdminModal(props) {
	const [showValidation, setShowValidation] = useState(false);
	const [userInformation, setUserInformation] = useState({});
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(setIsModalOpen(true));
		return () => {
			dispatch(clearErrors()).then(() => {
				dispatch(setIsModalOpen(false));
			});
		};
	}, []);

	const onUserSelectionChange = (user) => {
		setUserInformation({...user.allProps, userRole: userInformation.userRole});
		setShowValidation(false);
	};

	const onUserClear = () => {
		setUserInformation({userRole: userInformation.userRole});
	};

	// On close of modal, update state for service request. This is used to show updated count in tabs.
	const handlerOnHideModal = () => {
		props.setShowAddAdminModal(false);
	};

	const onSaveClick = () => {
		if (
			!userInformation.email ||
			!userInformation.firstName ||
			!userInformation.lastName ||
			!userInformation.userRole
		) {
			setShowValidation(true);
		} else {
			setShowValidation(false);
			var requestUrl = env.getBaseURL(serviceURL) + 'Admins';
			let model = {
				userId: userInformation.email,
				firstName: userInformation.firstName.trim(),
				lastName: userInformation.lastName.trim(),
				emailId: userInformation.email,
				isAdmin: {
					isAdminReader: userInformation.userRole === 'IsAdminReader',
					isAdminWriter: userInformation.userRole === 'IsAdminWriter',
					isSuperAdmin: userInformation.userRole === 'IsSuperAdmin'
				}
			};
			dispatch(createAdminUser(requestUrl, model))
				.then(() => {
					props.setShowAddAdminModal(false);
					dispatch(getAllAdminUsers(env.getBaseURL(serviceURL) + 'Admins'));
				})
				.catch((errorResponse) => {
					//displayCustomError(errorResponse);
				});
		}
	};
	const formatOptionLabel = ({value, label}) => (
		<section>
			<section style={{'font-weight': 'bold'}}>{value}</section>
			<section style={{'font-size': 'small', display: 'none'}}>{label}</section>
		</section>
	);

	const ModalHeader = () => {
		return (
			<StyledModalHeader className="modalHeader">
				<span title={labels.addNewAdmin}>{labels.addNewAdmin}</span>
			</StyledModalHeader>
		);
	};

	const renderSelect = () => {
		const options = AdminRoles.map((role) => {
			return {
				...role,
				id: role.value,
				label: currentResource.AdminRoles.find((x) => x.id === role.id)?.label
			};
		});

		const onChange = (option) => {
			if (option && option.value !== '') {
				setUserInformation({...userInformation, userRole: option});
			}
		};

		const selectProps = {
			label: labels.role,
			options,
			value: userInformation.userRole?.value || null,
			onChange
		};

		if (showValidation && !userInformation.userRole) selectProps.errorMessage = labels.required;

		return <Select {...selectProps} />;
	};

	return (
		<>
			<StyledMotifModalBody className="customScrollbar">
				<section className={'servicereq-edit-content'}>
					<ModalControl
						title={<ModalHeader />}
						closeTitle={labels.closeLabel}
						confirmBtnTitle={labels.add}
						onOkClick={onSaveClick}
						closeBtnTitle={labels.cancelLabel}
						modalsize="medium"
						onHide={handlerOnHideModal}
						show={true}
						showButtons={true}
						modalContainerClass="add-admin-modal"
					>
						<StyledModalContentSection className="customScrollbar">
							<ErrorSummary />
							<TrackerLoader
								areas={[promiseAreas.SERVICE_REQUEST_USERS_SAVE_AREA, promiseAreas.GET_ENGAGEMENT_TEAM_MEMBERS_DETAILS]}
								view="inlineView"
								fullscreen={false}
								styleName="tracker-Loader"
							/>
							<section className="instruction-text">
								<p>{labels.addEYContactInstructions}</p>
							</section>
							<StyledAddUser className={props.className} id={props.id}>
								<section className="search-box-wrapper">
									<UserSearch
										// TODO: Add proper label
										key={props.id}
										id={props.id}
										showValidations={showValidation && !userInformation.email}
										onUserClear={onUserClear}
										onUserSelectionChange={onUserSelectionChange}
										lookupType={UserLookupType.Admin}
										userError={props.userError}
										isNewAdd={props.isNewAdd}
										maxSearchLength={100}
										user={{}}
										isDisabled={false}
										canClearSelectedValue={true}
										clearUserData={props.clearData}
										hideClearIcon={props.hideClearIcon}
										onLabelClickSetFocus={true}
										hideUserSearchPlaceholder={true}
										formatOptionLabel={formatOptionLabel}
										showNameOnSelect={true}
										showNameInOptions={true}
									/>
								</section>
								<section className="textbox-wrapper">
									<div className="group-input-textbox">
										<Input
											id={'firstname_' + props.id}
											label={labels.firstName}
											maxLength="500"
											value={userInformation.firstName}
											errorMessage={showValidation && !userInformation.firstName ? labels.required : null}
											onChange={(e) => {
												setUserInformation({...userInformation, firstName: e.target.value});
											}}
										/>
									</div>
									<div className="group-input-textbox">
										<Input
											id={'lastname' + props.id}
											label={labels.lastName}
											maxLength="500"
											value={userInformation.lastName}
											errorMessage={showValidation && !userInformation.lastName ? labels.required : null}
											onChange={(e) => {
												setUserInformation({...userInformation, lastName: e.target.value});
											}}
										/>
									</div>
									{renderSelect()}
								</section>
							</StyledAddUser>
						</StyledModalContentSection>
					</ModalControl>
				</section>
			</StyledMotifModalBody>
		</>
	);
}

export default withRouter(AddAdminModal);

const StyledAddUser = styled.section`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	padding: 0 2rem;
	.user-selectbox {
		display: inline-block;
		width: 100%;
	}
	.search-box-wrapper {
		padding-bottom: 1rem;
		width: 60%;

		.enterdetail-description {
			bottom: 0;
		}
		.react-select__input input {
			width: 92% !important;
		}
		.clearall {
			right: 1rem;
		}
	}
	.textbox-wrapper {
		display: flex;
		.group-input-textbox,
		.motif-form-field-select-input {
			width: 30%;
		}
		.group-input-textbox {
			margin-right: 1rem;
		}
		.motif-select-field-list {
			background: ${(props) => props.theme.color[`grey100grey450`]};
		}
		.motif-select-trigger {
			font-size: 1.4rem;
			height: 5rem;
			background: ${(props) => props.theme.color[`grey100grey450`]};
			&:hover:not(:disabled),
			&:focus:not(:disabled) {
				background: ${(props) => props.theme.color[`grey100grey450`]};
			}
		}
		.motif-option-text,
		.motif-label {
			width: 100%;
			font-size: 1.4rem;
		}
		.motif-label,
		.motif-select-trigger svg {
			top: 1.8rem;
		}
		.motif-form-field-select-input {
			&.motif-form-field-has-value .motif-label {
				font-size: 1.2rem;
			}
		}
		.motif-select-list-options {
			display: flex;
			flex-direction: column;
			.motif-option {
				padding: 0 1rem;
			}
		}
	}
	.search-box-wrapper,
	.group-input-textbox,
	.clearall {
		flex-grow: 1;
	}
	.clearall {
		margin-top: 1.3rem;
		svg {
			fill: ${(props) => props.theme.color[`black`]};
		}
	}
	.group-input-textbox {
		width: 10rem;
		.motif-input {
			text-overflow: ellipsis;
			height: 5rem;
			&[disabled] {
				border: 0 !important;
				&::placeholder {
					color: ${(props) => props.theme.color[`white`]};
				}
			}
		}
		svg {
			&.small {
				width: 2rem;
				height: 2rem;
				max-width: 2rem;
				max-height: 2rem;
			}
		}

		.motif-disabled {
			&.motif-label-for-text {
				color: ${(props) => props.theme.color[`grey400`]} !important;
			}
		}
		.motif-form-field {
			.manage-admin-dropdown {
				.motif-select-input {
					padding-top: 0;
					min-height: 4.4rem;
					height: 4rem;
					.motif-select-input-arrow {
						top: 1.3rem;
					}
				}
				.motif-select-wrapper-options {
					top: 200%;
					.motif-select-options {
						.motif-option {
							display: flex;
						}
					}
				}
			}
		}
	}
	.motif-input-component {
		width: 100%;
	}

	.motif-input-component .motif-input:disabled {
		background: ${(props) => props.theme.color[`grey100grey450`]} !important;
	}
	.user-selectbox {
		.select-group {
			&.select-disabled {
				cursor: default;
			}
		}
	}

	.motif-error-message {
		color: ${(props) => props.theme.color[`red600`]};
		margin-top: 0.5rem;
		font-size: 1.3rem;

		svg {
			width: 2rem;
			height: 2rem;
			max-width: 2rem;
			max-height: 2rem;
			fill: ${(props) => props.theme.color[`red600`]};
			margin: 0 0.5rem 0 0;
			vertical-align: text-bottom;
		}
	}
`;

const StyledModalHeader = styled.section`
	&.modalHeader {
		display: flex;
		span {
			max-width: 100%;
			margin-right: 1rem;
			display: inline-block;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
`;
const StyledModalContentSection = styled.section`
	height: 30rem;
	position: relative;

	.errorMessageWrapper {
		position: absolute;
		top: 1rem;
		width: 96.5%;
	}

	.tracker-Loader {
	}
	.motif-progress-loader-container {
		&.inlineView {
			background-color: ${(props) => props.theme.color[`white`]};
			height: 100%;
			position: absolute !important;
			opacity: 0.5;
		}
		.motif-loader-content {
			position: absolute;
			top: 50%;
		}
	}

	.default-message-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.requiredLabel {
		display: flex;
		justify-content: center;
		color: ${(props) => props.theme.color[`red600`]};
		font-size: 1.4rem;
		font-weight: bold;
		margin-left: 0.5rem;
	}

	.default-placeholder {
		width: 50%;
		font-size: 1.2rem;
		color: ${(props) => props.theme.color[`grey500`]};
		text-align: center;
	}

	.ellipsis {
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
	.add-group-name {
		width: 100%;
	}

	.group-name-wrap {
		min-height: 26rem;
		max-height: 26rem;
		padding: 0 2rem;
		width: 100%;
	}
	.add-group-wrap {
		display: flex;
		justify-content: space-between;
		width: 100%;
		margin: 0;

		.select-up {
			.react-select__menu {
				top: 100% !important;
				bottom: auto !important;
			}
		}
	}

	.instruction-text {
		width: 100%;
		padding: 2rem 2rem;
		p {
			margin: 0;
			font-size: 1.4rem;
			line-height: 2rem;
			.selected-offering {
				color: ${(props) => props.theme.color[`teal400`]};
				font-weight: bold;
			}
		}
	}
`;
const StyledMotifModalBody = styled(MotifModalBody)`
	.motif-loader.motif-progress-loader-container.saveRequestUsersLoader {
		z-index: 999;
		top: 6.4rem;
		height: 100%;
		left: 0;
		position: absolute;
	}
	padding: 1.5rem 2rem !important;
	max-height: 50rem;

	h4 {
		font-size: 1.6rem;
		font-weight: normal;
		margin: 0 0 1rem;
	}
	p {
		font-size: 1.2rem;
		font-weight: 300;
		margin-bottom: 0;
	}
	.required-error {
		font-size: 1.3rem;
		display: flex;
		align-items: center;
		color: ${(props) => props.theme.color[`red600`]};

		svg {
			fill: ${(props) => props.theme.color[`red600`]};
			margin-right: 0.5rem;
		}
	}
	.motif-input {
		border-radius: 0;
		border-bottom: 0.1rem solid ${(props) => props.theme.color[`grey500`]} !important;
		box-shadow: none !important;
		&:hover,
		&:focus,
		&:active {
			border-bottom: 0.1rem solid ${(props) => props.theme.color[`grey500`]} !important;
			box-shadow: none !important;
		}
	}

	.motif-input-component .motif-input {
		padding: 2rem 3rem 0.8rem 1rem;
	}

	.modal-section {
		margin-bottom: 3rem;
	}
	.modal-header {
		padding: 0;
		border-bottom: none;
		.group-name-input-wrapper {
			max-width: 45rem;
			.group-input-textbox {
				svg {
					&.small {
						width: 2rem;
						height: 2rem;
						max-width: 2rem;
						max-height: 2rem;
					}
				}
				.motif-input-clear-button {
					top: 1.6rem;
				}
			}
		}

		.padded-top {
			padding-top: 1.5rem;
		}
	}
`;
